<template>
  <div class="manage-expense-admin-plus">
    <v-container class="font-roboto">
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="rounded-lg" elevation="0">
            <v-card-title class="d-flex justify-space-between align-center pb-2">
              <span class="text-h5 font-weight-regular">{{ existing ? $t("message.transactions_admin_plus.edit_expense") : $t("message.transactions_admin_plus.add_expense") }}</span>

            </v-card-title>
            <v-card-subtitle class="py-4 plusTextSecondary--text text-body-1">
              {{$t("message.transactions_admin_plus.add_expense_explained")}}
              
            </v-card-subtitle>

            <v-card-text>
              <v-text-field outlined dense maxlength="50" :label="$t('message.name')" v-model="itemName" />


              <v-col cols="12" md="3" class="pa-0">
                <DatePicker coluns="3" class="mb-4" v-model="itemDate" :past-event="true" :label="'Expense date'" />

              </v-col>
              <v-textarea rows="3" outlined dense :label="$t('message.description')" v-model="itemDescription" />

              <v-combobox class="mt-4" :items="availableTags" v-model="tags" :search-input.sync="search" small-chips
                dense outlined :label="$t('message.category')">
                <template slot="no-data">
                  <v-list-item>
                    <span class="subheading">{{ $t('message.click_enter_add_new') }}:</span>
                    <v-chip label small>{{ search }}</v-chip>
                  </v-list-item>
                </template>
              </v-combobox>

              <v-row class="mt-2">
                <v-col cols="12" md="6">
                  <v-text-field hide-details outlined dense :rules="[numberRule]" :label="$t('message.amount')"
                    v-model="price" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field hide-details outlined dense disabled v-model="currencyText"
                    :label="$t('message.currency')" />
                </v-col>
              </v-row>

              <v-text-field class="mt-4" hide-details outlined dense :rules="[numberRule]" :label="$t('message.transactions_admin_plus.tax_amount')"
                v-model="tax" />

              <v-textarea class="mt-4" rows="3" outlined dense :label="$t('message.notes')" v-model="notes" />

              <div class="mt-4">
                <members-autocomplete :label="'Assign beneficiary'" v-model="assignMemberId" />
              </div>

              <div class="mt-6 text-subtitle-1 font-weight-medium d-flex align-center">
                <v-icon class="mr-2" size="20">mdi-receipt-text-outline</v-icon>
                <span>{{ $t("message.upload_receipt") }}</span>
              </div>

              <div class="receipt-drop mt-3 pa-6 text-center">
                <div v-if="receipt">
                  <ImageDisplay :src="receipt" style="max-width: 100%;" />
                  <div class="mt-3">
                    <v-btn small color="error" @click="receipt = null;">
                      <v-icon left>mdi-trash-can-outline</v-icon>
                      {{ $t("message.delete") }}
                    </v-btn>
                  </div>
                </div>
                <div v-else class="d-flex justify-center align-center" style="gap: 8px">
                  <div class="text-body-1 ">{{$t("message.academy_settings_admin_plus.drag_and_drop_or")}}</div>
                  <v-btn small elevation="0" class="upload-image-btn" @click="filePicker()">
                    {{$t("message.academy_settings_admin_plus.upload_image")}}
                  </v-btn>
                </div>
              </div>

              <v-progress-linear v-if="uploading" indeterminate color="secondary" class="mt-3" />
              <div v-if="uploadingMessage" class="text-center mt-2">{{ uploadingMessage }}</div>
              <input style="display: none" type="file" accept="image/*" @change="onFileSelect" ref="fileUploadInput" />
            </v-card-text>

            <v-card-actions class="px-6 pb-6">
              <v-btn outlined @click="goBack()">Cancel</v-btn>
              <PlusButton intent="primary" class="ml-3" :loading="handlingCharges"
                :disabled="!(validQuantity && itemName)" v-if="transactionId == 'new'" @click="addExpense()">
                {{$t("message.transactions_admin_plus.add_expense")}}
              </PlusButton>
              <PlusButton intent="primary" class="ml-3" :loading="handlingCharges" v-else
                :disabled="validQuantity && itemName && existing" @click="updateExpense()">
                {{$t("message.transactions_admin_plus.update_expense")}}
              </PlusButton>
              <v-spacer />
              <v-btn v-if="transactionId != 'new'" color="error" text @click="deleteExpenseDialog = true">
                <v-icon left>mdi-trash-can-outline</v-icon>
                {{ $t("message.delete") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="deleteExpenseDialog" max-width="90%">
      <v-card class="pa-2">
        <v-card-text>{{ $t('message.delete_item_confirm') }}</v-card-text>
        <v-card-actions>
          <v-btn elevation="0" color="error" @click.stop="removeExpense()">{{ $t('message.delete') }}</v-btn>
          <v-btn small elevation="0" @click.stop="deleteExpenseDialog = false">{{ $t('message.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DatePicker from "@/components/inputs/DateTimePicker.vue";
import MembersAutocomplete from "@/components/inputs/MembersAutocomplete.vue";
import ImageDisplay from "@/components/displays/ImageDisplay.vue";
import Api2 from "@/services/Api2";
import { mask } from "vue-the-mask";
import PlusButton from "@/components/plus/PlusButton.vue";

export default {
  directives: { mask },
  components: { DatePicker, MembersAutocomplete, ImageDisplay, PlusButton },
  data() {
    return {
      loading: true,
      transactionId: this.$route.params.transactionId,
      itemName: null,
      itemDate: new Date(),
      handlingCharges: false,
      itemDescription: null,
      assignBuyerDialog: null,
      assignMemberId: null,
      checkoutInitialized: false,
      validQuantity: true,
      currencyText: null,
      price: null,
      tax: null,
      mask1: "#########",
      tags: null,
      availableTags: [],
      existing: false,
      mask2: "##",
      priceDecimal: "00",
      uploading: false,
      uploadingMessage: null,
      quantity: 1,
      receipt: null,
      checkins: null,
      buyer: null,
      selectedFile: null,
      search: null,
      paymentForm: false,
      deleteExpenseDialog: false,
      uploadedReceipt: null,
      notes: null,
      currency: null,
      numberRule: (v) => {
        if (v && !v + "".trim()) return true;
        if (v && !isNaN(parseFloat(v)) && v >= 0) return true;
        return this.$t("message.invalid_number");
      },
    };
  },
  created() {
    Api2()
      .getWithCache("admins/academy/" + this.$store.state.selectedAcademy, {}, 60)
      .then((response) => {
        this.currency = response.currency;
        this.currencyText = response.currency ? response.currency.toUpperCase() : "???";
      });
    this.getAvailableTags();
    if (this.transactionId == "new") {
      this.quantity = 1;
    } else {
      this.existing = true;
      this.getTransactionData();
    }
  },
  watch: {
    quantity: {
      handler: function (newValue) {
        this.checkAmountValidity(newValue);
      },
    },
  },
  methods: {
    getTransactionData() {
      Api2()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/payments/transactions/" + this.transactionId)
        .then((response) => {
          const transaction = response.data.transaction;
          this.checkins = transaction.checkins;
          this.buyer = transaction.buyer;
          this.receipt = transaction.receipt;
          this.notes = transaction.notes;
          if (transaction.buyer && transaction.buyer._id) {
            this.assignMemberId = transaction.buyer._id;
          }
          if (transaction.tags) this.tags = transaction.tags[0];
          if (transaction.items && transaction.items.length == 1) {
            this.itemDescription = transaction.items[0].description;
            this.itemName = transaction.items[0].name;
            this.itemDate = new Date(transaction.completed);
            this.priceDecimal = 0;
            if (transaction.amount < 0) {
              const amount = (transaction.amount * -1).toFixed(2);
              this.price = amount;
              this.priceDecimal = amount.substring(amount.length - 2, amount.length);
            } else {
              this.price = 0;
              this.priceDecimal = 0;
            }
            if (transaction.tax > 0) this.tax = transaction.tax;
          }
        });
    },
    getAvailableTags() {
      Api2()
        .get("payments/academy/" + this.$store.state.managedAcademy + "/transactions/tags/all")
        .then((response) => {
          const data = response.data;
          if (data) this.availableTags = data.tags;
        });
    },
    filePicker() {
      this.$refs.fileUploadInput.click();
    },
    onFileSelect(event) {
      this.uploading = true;
      if (event.target.files[0]) {
        this.receipt = null;
        this.selectedFile = event.target.files[0];
        const sizeMb = Math.floor(event.target.files[0].size / 1000000);
        if (sizeMb <= 15) {
          this.uploadPhoto();
        } else {
          this.uploading = false;
          this.showAlert("error", "Sorry! Your image is too big (" + sizeMb + "mb), try a smaller one.");
        }
      } else {
        this.uploading = false;
      }
    },
    uploadPhoto() {
      const formData = new FormData();
      this.uploadingMessage = this.$t("message.image_upload_progress");
      const millis = new Date().getTime();
      const imgExtension = this.selectedFile.type.toLowerCase().split("/")[1];
      const blob = new Blob([this.selectedFile], { type: this.selectedFile.type });
      formData.append("image", blob, "bjjlink-user-admin-uploaded-image-" + millis + "." + imgExtension);
      Api2().post("content/image/admin", formData).then((res) => {
        const data = res.data;
        if (data) {
          setTimeout(() => {
            this.receipt = data.original;
            this.uploadedReceipt = data;
            this.uploadingMessage = null;
            this.uploading = false;
          }, 4000);
        }
      }).catch(() => {
        this.showAlert("error", "Oops!", ":(");
        this.uploading = false;
      });
    },
    checkAmountValidity(q) {
      this.validQuantity = !isNaN(q) && q != "";
      if (this.validQuantity && this.quantity <= 0) this.validQuantity = false;
    },
    removeExpense() {
      Api2()
        .delete("payments/academy/" + this.$store.state.managedAcademy + "/expenses/" + this.transactionId)
        .then((response) => {
          if (response.data) this.goBack();
        })
        .catch((e) => {
          if (e) this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    updateExpense() {
      const postData = {
        items: this.setupItems(),
        receipt: this.receipt,
        tax: this.tax,
        processedBy: "desk",
        quantity: this.quantity,
        completed: this.itemDate,
        tags: [this.tags],
        notes: this.notes,
      };
      Api2()
        .patch("payments/academy/" + this.$store.state.managedAcademy + "/expenses/" + this.transactionId, postData)
        .then((response) => {
          if (response.data) this.showAlert("success", this.$t("message.updated"));
        })
        .catch((e) => {
          this.handlingCharges = false;
          if (e) this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    addExpense() {
      this.handlingCharges = true;
      const items = this.setupItems();
      if (!items) {
        this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        return;
      }
      const postData = {
        items,
        receipt: this.uploadedReceipt ? this.uploadedReceipt.location : null,
        completed: this.itemDate,
        processedBy: "desk",
        tax: this.tax,
        quantity: this.quantity,
        tags: [this.tags],
      };
      Api2()
        .post("payments/academy/" + this.$store.state.managedAcademy + "/expenses/new", postData)
        .then((response) => {
          if (response.data) this.goBack();
        })
        .catch((e) => {
          this.handlingCharges = false;
          if (e) this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    setupItems() {
      if (this.priceDecimal == "") this.priceDecimal = "00";
      else if (this.priceDecimal.length == 1) this.priceDecimal = this.priceDecimal + "0";
      const amountDecimal = new Number(this.price);
      if (!amountDecimal || amountDecimal <= 0) return null;
      return [
        {
          name: this.itemName,
          description: this.itemDescription,
          amountDecimal: amountDecimal.valueOf(),
          currency: this.currency,
          quantity: this.quantity,
        },
      ];
    },
  },
};
</script>

<style scoped>
.manage-expense-admin-plus {
  background: var(--v-plusBackground-base);
  min-height: 100%;
}

.receipt-drop {
  border: 1px dashed var(--v-plusBorder-base);
  border-radius: 6px;
  background: var(--v-plusSurface-base);
}

/* Upload action: secondary/link-style button.
   Uses Vuetify CSS variables so colors swap automatically between themes. */
.upload-image-btn.v-btn:not(.v-btn--disabled) {
  background-color: var(--v-plusGreyLighten3-base) !important;
  color: var(--v-plusBlueDarken1-base) !important;
}

.theme--dark .upload-image-btn.v-btn:not(.v-btn--disabled) {
  background-color: var(--v-plusGreyDarken3-base) !important;
  color: var(--v-plusIndigoLighten1-base) !important;
}
</style>
